import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allLiveWebinars: [],
    loading: false,
    error: null,
};

const liveWebinarSlice = createSlice({
    name: 'liveWebinar',
    initialState,
    reducers: {
        setAllLiveWebinars: (state, action) => {
            state.allLiveWebinars = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
    },
    extraReducers: (builder) => {
    },
});

export const { setAllLiveWebinars } = liveWebinarSlice.actions;

export default liveWebinarSlice.reducer;